var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CafeteriaDeliveriesForm',{attrs:{"typeEndPoint":'cafeteriaDeliveriesForm',"dataParams":{}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08bf71bd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/cafeteria/deliveries/create.vue
// module id = null
// module chunks = 